import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import { signInWithGoogle } from "@/utils/auth";

const Integrations = () => {
  const navigate = useNavigate();

  const handleSignIn = async () => {
    try {
      await signInWithGoogle();
    } catch (error) {
      console.error('Sign in failed:', error);
    }
  };

  const integrations = [
    {
      name: "Shopify",
      logo: "https://ancujowsxivyfnxhnsmr.supabase.co/storage/v1/object/public/images/shopify-logo.svg",
      description: "Publish directly to your Shopify store",
      link: "/docs/shopify-integration",
      status: "available"
    },
    {
      name: "WordPress",
      logo: "https://ancujowsxivyfnxhnsmr.supabase.co/storage/v1/object/public/images/WordPress_blue_logo.svg",
      description: "Connect with your WordPress site",
      link: "/docs/wordpress-integration",
      status: "available"
    },
    {
      name: "Webflow",
      logo: "https://ancujowsxivyfnxhnsmr.supabase.co/storage/v1/object/public/images/Mark_Logo_Blue.svg",
      description: "Integrate with Webflow projects",
      link: "/docs/webflow-integration",
      status: "available"
    },
    {
      name: "Framer",
      logo: "https://ancujowsxivyfnxhnsmr.supabase.co/storage/v1/object/sign/random%20images/framer.svg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV8xOWQwMmZkMy05MzllLTQ3YWYtODEyYS0zOWQxMTc0NGY2N2IiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJyYW5kb20gaW1hZ2VzL2ZyYW1lci5zdmciLCJpYXQiOjE3NjQyNDc1NzksImV4cCI6MTkyMTkyNzU3OX0.Gu1gIBRsicbTGv-BvevnBi8YCteGS7cUz35GMijvz7c",
      description: "OAuth integration coming soon",
      link: "/docs/framer-integration",
      status: "coming-soon"
    }
  ];

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <SEO
        title="CMS Integrations - Shopify, WordPress, Webflow | Seoro"
        description="Connect Seoro with your favorite CMS platforms. Publish SEO-optimized articles directly to Shopify, WordPress, and Webflow with one click. Framer integration coming soon!"
        keywords="Shopify integration, WordPress integration, Webflow integration, CMS integration, content publishing, SEO content automation, one-click publishing"
      />
      <Header onSignIn={handleSignIn} />
      
      <main className="flex-1 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24">
        <div className="space-y-12">
          <div className="text-center space-y-4">
            <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-foreground">
              Integrations
            </h1>
            <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
              Connect Seoro with your favorite platforms and tools.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {integrations.map((integration, index) => {
              return (
                <a
                  key={index}
                  href={integration.link}
                  className="bg-muted/30 rounded-xl p-8 hover:bg-muted/50 transition-all hover:shadow-lg group"
                >
                  <div className="flex items-start gap-4">
                    <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center">
                      <img
                        src={integration.logo}
                        alt={integration.name}
                        className="h-10 w-auto max-w-[120px] object-contain group-hover:scale-110 transition-transform"
                      />
                    </div>
                    <div className="flex-1">
                      <div className="flex items-center justify-between mb-2">
                        <h3 className="text-xl font-bold text-foreground">{integration.name}</h3>
                        {integration.status === "available" && (
                          <span className="text-xs px-2 py-1 rounded-full bg-primary/10 text-primary">
                            Available
                          </span>
                        )}
                        {integration.status === "coming-soon" && (
                          <span className="text-xs px-2 py-1 rounded-full bg-yellow-500/10 text-yellow-600 dark:text-yellow-500">
                            Coming Soon
                          </span>
                        )}
                      </div>
                      <p className="text-muted-foreground mb-4">{integration.description}</p>
                      <span className="text-sm text-primary font-semibold group-hover:underline">
                        Learn more →
                      </span>
                    </div>
                  </div>
                </a>
              );
            })}
          </div>

          <div className="bg-muted/30 rounded-2xl p-8 text-center">
            <h2 className="text-2xl font-bold text-foreground mb-4">More Integrations Coming Soon</h2>
            <p className="text-muted-foreground mb-6">
              We're constantly expanding our integration options. Contact us if you need support for a specific platform.
            </p>
            <Button
              onClick={() => navigate('/contact')}
              className="rounded-full bg-gradient-to-r from-primary via-primary to-primary/90"
            >
              Request Integration
            </Button>
          </div>
        </div>
      </main>

      <Footer onSignIn={handleSignIn} />
    </div>
  );
};

export default Integrations;


